module.exports = __webpack_public_path__ + "img/3d_doc.353e8c1.png";